import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-warning-o',
  templateUrl: './icon-warning-o.component.html',
  styles: []
})
export class IconWarningOComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
